import { call, put, takeLatest } from "redux-saga/effects";
import {
    downloadSampleFileFailure,
    downloadSampleFileSuccess,
    uploadPlanExcelFailure,
    uploadPlanExcelSuccess,
    getPdfDataNewFail,
    getPdfDataNewSuccess,
    getSampleExcelFail,
    getSampleExcelSuccess,
    exportExcelFail,
    exportExcelSuccess,
} from "./slice";
import {
    downloadPlanExcel,
    uploadPlanExcel,
    getPdfDataNew,
    getSampleExcel,
    importExcel,
    exportExcelMaterial,
} from "../../api/backend_helper";

function* onDownloadSampleFile(action) {
    try {
        const response = yield call(downloadPlanExcel, action.payload);
        yield put(downloadSampleFileSuccess(response));
    } catch (error) {
        yield put(downloadSampleFileFailure(error));
    }
}

function* onUploadPlanExcel(action) {
    try {
        const { type, file } = action.payload;
        const formData = new FormData();
        formData.append("file", file);
        const response = yield call(uploadPlanExcel, type, formData);
        yield put(uploadPlanExcelSuccess(response));
    } catch (error) {
        yield put(uploadPlanExcelFailure(error));
    }
}

function* getPdfDataNewSaga(action) {
    try {
        const {
            productIds,
            type,
            buildingIds,
            startAt,
            endAt,
            filterTeamWorking,
            orderCode,
            category,
            factoryCode,
            filterUnit,
        } = action.payload;
        const data = yield call(getPdfDataNew, {
            productIds,
            type,
            buildingIds,
            startAt,
            endAt,
            filterTeamWorking,
            orderCode,
            category,
            factoryCode,
            filterUnit,
        });
        yield put(getPdfDataNewSuccess(data));
    } catch (error) {
        yield put(getPdfDataNewFail(error.message));
    }
}

function* getSampleExcelSaga(action) {
    try {
        const response = yield call(getSampleExcel, action.payload);
        yield put(getSampleExcelSuccess(response));
    } catch (error) {
        yield put(getSampleExcelFail(error));
    }
}
function* importExcelSaga(action) {
    try {
        const response = yield call(
            importExcel,
            action.payload.type,
            action.payload.file
        );
        yield put(getSampleExcelSuccess(response));
    } catch (error) {
        yield put(getSampleExcelFail(error));
    }
}
function* exportExcelSaga(action) {
    try {
        const data = yield call(exportExcelMaterial, action.payload);
        yield put(exportExcelSuccess(data));
    } catch (error) {
        yield put(exportExcelFail(error));
    }
}
export default function* ExcelSaga() {
    yield takeLatest("excel/downloadSampleFileRequest", onDownloadSampleFile);
    yield takeLatest("excel/uploadPlanExcelRequest", onUploadPlanExcel);
    yield takeLatest("excel/getPdfDataNew", getPdfDataNewSaga);
    yield takeLatest("excel/getSampleExcel", getSampleExcelSaga);
    yield takeLatest("excel/importExcel", importExcelSaga);
    yield takeLatest("excel/exportExcel", exportExcelSaga);
}
